import { render } from "./WaitingApproveImageModal.vue?vue&type=template&id=49583734&scoped=true&ts=true"
import script from "./WaitingApproveImageModal.vue?vue&type=script&lang=ts"
export * from "./WaitingApproveImageModal.vue?vue&type=script&lang=ts"

import "./WaitingApproveImageModal.vue?vue&type=style&index=0&id=49583734&lang=scss&scoped=true"
import "./WaitingApproveImageModal.vue?vue&type=style&index=1&id=49583734&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49583734"]])

export default __exports__